import { Button } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

const Signin = () => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const invitationToken = queryParams.get("invite"); // Get the token parameter from the URL

  if (invitationToken) {
    localStorage.setItem("invitation_token", invitationToken);
  }

  return (
    <div className="login-page">
      <div className="login-header">
        <div className="logo-text">
          <img src="/assets/images/bg/logo-wide-white.png" alt="" />
          <img src="/assets/images/bg/portal-img.png" alt="" />
        </div>
      </div>

      <div className="icon-box">
        <img src="/assets/images/bg/star-pink.png" alt="star icon" />
      </div>

      <div className="login-content">
        <Button
          onClick={() => loginWithRedirect({ prompt: "login" })}
          block
          type="primary"
          htmlType="submit"
          className="login-button"
        >
          Log in
        </Button>{" "}
      </div>
    </div>
  );
};
export default Signin;
